import { currencyFormat } from 'shared/utils/formatter';

const CurrencyFormat = ({ value, currency, locale, ...opts }) => currencyFormat(value, { currency, ...opts }, locale);

export default CurrencyFormat;
